<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">Teklif Detayı Doğrulaması.</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="modal-body" tabindex="0" ngbAutofocus>
    <form [formGroup]="form">
  
      <label for="seriNo">Kod</label>
      <div class="form-group">
        <input type="number" id="seriNo" formControlName="code"
          placeholder="Kod giriniz." class="form-control" />
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="closeModal()" rippleEffect>
      İptal
    </button>
    <button type="button" class="btn btn-success" (click)="onSubmit()" rippleEffect>
      Ekle
    </button>
  </div>
  